import { useTranslation } from "../../i18n/LanguageProvider";
import groupedByYear from "../publications/useBibtexData.js";

import ProjectCard from "./ProjectCard.jsx";
import projectsData from "./projectsData.js";

function findPublicationById(pubId) {
  for (const year in groupedByYear) {
    const publication = groupedByYear[year].find((item) => item.id === pubId);
    if (publication) {
      return publication;
    }
  }

  return null;
}

export default function Projects() {
  const { t } = useTranslation();
  return (
    <section>
      <h1 className="page-title">{t("nav.projects")}</h1>
      {projectsData.map((project) => {
        const publications = project.relatedPublications
          .map(findPublicationById)
          .filter(Boolean);

        return (
          <ProjectCard
            key={project.id}
            project={project}
            publications={publications}
          />
        );
      })}
    </section>
  );
}
